import { HttpClient, RequestConfig } from "@planzone/services";

function createChatbotUrlProvider(httpClient: HttpClient): HttpClient {
  return {
    sendHttpRequest<Response>(config: RequestConfig): Promise<Response> {
      return httpClient.sendHttpRequest({
        baseUrl: "/assistant-api",
        ...config,
      });
    },
  };
}

export { createChatbotUrlProvider };
